import { isNil } from 'lodash'
import moment from 'moment'

import { stringToDate } from 'modules/core/lib/dates'

import { InboxRequest } from '../hooks/useNotificationsRequests'

export function requestCount(requests: InboxRequest[]) {
  const requestDueDate = (request: InboxRequest) =>
    request.dueDate && stringToDate(request.dueDate, 'backend_datetime')

  const requestsWithDueDate = () => requests.filter((request) => !isNil(request.dueDate))

  const dueTodayCounter = requestsWithDueDate().filter((request) =>
    moment().isSame(requestDueDate(request), 'day')
  ).length

  const overdueCounter = requestsWithDueDate().filter((request) =>
    moment().isAfter(requestDueDate(request), 'day')
  ).length

  return {
    dueTodayCounter,
    overdueCounter,
  }
}
